import { ITaskCustomView } from 'components/Tasks/TaskViews/TaskViewTypes';

const buildViewSlugFromLabel = (label: string): string => {
  const slug = label
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return slug || 'view';
};

export const getCustomViewRouteId = (view: Pick<ITaskCustomView, 'key' | 'taskViewId'>): string =>
  view.taskViewId ? `${view.taskViewId}` : view.key;

export const getCustomViewUrl = (routeId: string, label: string): string =>
  `/view/${routeId}/${buildViewSlugFromLabel(label)}`;

export const getViewLabelForDisplay = (label: string): string => label.trim();

export const getCustomViewRouteIdFromPath = (pathname: string, sceneBaseURL: string): string | undefined => {
  const prefix = `${sceneBaseURL}/view/`;
  if (!pathname.startsWith(prefix)) return undefined;

  const suffix = pathname.substring(prefix.length);
  const routeId = suffix.split('/')[0];

  return routeId || undefined;
};
